import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "../core/authentication.service";
import { HttpErrorResponse } from "@angular/common/http";
import { DataStoreServiceService } from "../dashboard/data-store-service.service";

@Component({
  selector: "app-verify",
  templateUrl: "./verify.component.html",
  styleUrls: ["./verify.component.scss"],
})
export class VerifyComponent implements OnInit {
  verificationCode: string = null;
  errorMsg: any;
  showError: boolean = false;
  hideForm = false;
  doctorRecord: any;
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.verificationCode = params["verificationCode"];
    });

    if (this.verificationCode) {
      this.verifyCode();
    }
  }
  verifyCode() {
    this.authService.codeVerification(this.verificationCode).subscribe({
      next: (res: any) => {
        this.doctorRecord = res["data"];
        localStorage.setItem("registerFirstName", res.data.firstName);
        localStorage.setItem("registerLastName", res.data.lastName);
        localStorage.setItem("registerGender", res.data.gender);
        localStorage.setItem("registerEmail", res.data.email);
        localStorage.setItem(
          "registerDoctorRole",
          res.data?.doctorRole ? res.data?.doctorRole : "",
        );

        this.router.navigate(["/register"]);
      },
      error: (error: HttpErrorResponse) => {
        this.errorMsg = error.error.errors;
        this.hideForm = true;
        this.showError = true;
        this.router.navigate(["/login"]);
      },
    });
  }
}
